import * as React from "react";
const SvgApify = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Apify_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#25458A",
  d: "M0 9.6c0-3.36 0-5.04.654-6.324A6 6 0 0 1 3.276.654C4.56 0 6.24 0 9.6 0h4.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C24 4.56 24 6.24 24 9.6v4.8c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C19.44 24 17.76 24 14.4 24H9.6c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C0 19.44 0 17.76 0 14.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7760A",
  d: "M12.666 8.693c.52.52.75 1.108 1.039 1.771l.179.407.37.852q.285.653.575 1.304l.36.828.175.393c.396.925.396.925.168 1.61-.46.243-.9.446-1.38.642l-.42.176q-.44.184-.882.365-.674.278-1.346.561-.428.18-.857.356l-.405.17c-.684.278-1.122.39-1.874.39.339-1.095.786-2.129 1.248-3.176l.245-.558.51-1.16.783-1.785.496-1.128.237-.542.22-.497.193-.439c.162-.335.162-.335.366-.54"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#68AF34",
  d: "M11.233 6.442a390 390 0 0 1-4.298 10.03c-.656-.984-.678-2.107-.844-3.263l-.113-.728c-.603-4.103-.603-4.103.151-5.246 1.37-.884 3.54-.82 5.104-.793"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0194C2",
  d: "M16.555 5.828c.551.445.912.8 1.228 1.433.24 2.313.23 4.636.205 6.959h-.614a2051 2051 0 0 1-1.86-4.159q-.34-.758-.679-1.518l-.213-.475-.2-.447-.174-.392a8 8 0 0 1-.354-1.196c.871-.218 1.771-.37 2.661-.205"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DE6F11",
  d: "M12.666 8.693c.41.41.41.41.435.947l-.025.486h-.82c.18-1.202.18-1.202.41-1.433"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Apify_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));
export default SvgApify;
//# sourceMappingURL=Apify.js.map